import { useNavigate } from 'react-router-dom'
import Logo from '../components/Logo'

const CONTENT = {
  terms: {
    title: '利用規約',
    sections: [
      {
        heading: '第1条（適用）',
        body: '本規約は、GitCraft（以下「本サービス」）の利用に関する条件を定めるものです。ユーザーは本規約に同意の上、本サービスをご利用ください。',
      },
      {
        heading: '第2条（サービスの内容）',
        body: '本サービスは、Gitの学習コンテンツをインタラクティブな形式で提供するWebアプリケーションです。コンテンツは予告なく変更・追加・削除される場合があります。',
      },
      {
        heading: '第3条（禁止事項）',
        body: 'ユーザーは以下の行為を行ってはなりません。①法令または公序良俗に違反する行為 ②本サービスの運営を妨害する行為 ③他のユーザーへの迷惑行為 ④本サービスのコンテンツを無断で複製・転載する行為',
      },
      {
        heading: '第4条（免責事項）',
        body: '本サービスの提供するコンテンツの正確性・完全性について保証するものではありません。本サービスの利用によって生じた損害について、当方は責任を負いません。',
      },
      {
        heading: '第5条（サービスの変更・停止）',
        body: '当方は、ユーザーへの事前通知なく本サービスの内容の変更または提供の停止を行うことができます。',
      },
      {
        heading: '第6条（規約の変更）',
        body: '当方は必要に応じて本規約を変更することがあります。変更後は本ページに掲載し、掲載時点より効力を生じるものとします。',
      },
      {
        heading: '第7条（準拠法・管轄）',
        body: '本規約の解釈・適用は日本法に準拠します。本サービスに関連する紛争については、東京地方裁判所を専属的合意管轄裁判所とします。',
      },
    ],
  },
  privacy: {
    title: 'プライバシーポリシー',
    sections: [
      {
        heading: '1. 取得する情報',
        body: '本サービスでは以下の情報を取得します。①Googleアカウントまたはメールアドレス・パスワードによる認証情報 ②お問い合わせフォームに入力された情報（氏名・メールアドレス・問い合わせ内容） ③アクセスログ（IPアドレス、ブラウザ情報等）',
      },
      {
        heading: '2. 利用目的',
        body: '取得した情報は以下の目的で利用します。①サービスの提供・運営 ②お問い合わせへの対応 ③サービスの改善・新機能の検討 ④統計データの作成（個人を特定しない形で）',
      },
      {
        heading: '3. 第三者への提供',
        body: '取得した個人情報は、法令に基づく場合を除き、ユーザーの同意なく第三者に提供しません。',
      },
      {
        heading: '4. 利用するサービス',
        body: '本サービスはFirebase（Google LLC）を認証・データベース基盤として利用しています。Firebase のプライバシーポリシーについては Google のウェブサイトをご確認ください。',
      },
      {
        heading: '5. クッキー・アクセス解析',
        body: '本サービスはサービス改善のためアクセス解析ツールを利用する場合があります。これらのツールはクッキーを使用してデータを収集しますが、個人を特定する情報は収集しません。',
      },
      {
        heading: '6. 情報の管理・削除',
        body: 'ご自身の情報の確認・削除を希望される場合は、お問い合わせページよりご連絡ください。',
      },
      {
        heading: '7. プライバシーポリシーの変更',
        body: '本ポリシーは予告なく変更する場合があります。変更後は本ページに掲載し、掲載時点より効力を生じるものとします。',
      },
    ],
  },
  tokushoho: {
    title: '特定商取引法に基づく表記',
    sections: [
      { heading: '販売業者', body: 'Craft Series 運営者' },
      { heading: 'サービス名', body: 'GitCraft' },
      { heading: '所在地', body: '請求があれば遅滞なく開示します' },
      { heading: '連絡先', body: 'トップページのお問い合わせフォームよりご連絡ください' },
      { heading: '販売価格', body: '現在、全コンテンツを無料で提供しています。有料プランを導入する場合は事前にサービス内でお知らせします。' },
      { heading: '支払方法', body: '現在、有料プランはありません' },
      { heading: 'サービスの提供時期', body: 'アカウント登録後、即時ご利用いただけます' },
      { heading: 'キャンセル・返品', body: '現在、有料プランはないため該当しません' },
      { heading: '動作環境', body: '最新版のChrome・Safari・Firefox・Edge推奨' },
    ],
  },
}

export default function LegalPage({ type }) {
  const navigate = useNavigate()
  const content = CONTENT[type]
  if (!content) return null

  return (
    <div
      className="min-h-screen"
      style={{
        background: 'linear-gradient(180deg, #0a0e1a 0%, #111827 100%)',
        fontFamily: "'Noto Sans JP', 'Inter', sans-serif",
      }}
    >
      <nav className="flex items-center gap-4 px-6 md:px-8 py-5 border-b border-white/10">
        <button
          onClick={() => navigate('/')}
          className="text-white/50 hover:text-white text-sm transition-colors"
        >
          ← トップ
        </button>
        <Logo size="md" />
      </nav>

      <div className="max-w-2xl mx-auto px-4 sm:px-6 md:px-8 py-16">
        <h1 className="text-3xl font-black text-white mb-10">{content.title}</h1>
        <div className="space-y-8">
          {content.sections.map((s, i) => (
            <div key={i}>
              <h2 className="text-sm font-bold text-white/80 mb-2">{s.heading}</h2>
              <p className="text-sm text-white/50 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-white/25 mt-12">最終更新：2026年3月</p>
      </div>
    </div>
  )
}
